'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'chess-rook-piece';
var width = 320;
var height = 512;
var aliases = ["chess-rook-alt"];
var unicode = 'f448';
var svgPathData = 'M16 64l0 106.7c0 13.8 4.5 27.3 12.8 38.4L64 256 64 384 7.8 454.3C2.7 460.6 0 468.4 0 476.5 0 496.1 15.9 512 35.5 512l248.9 0c19.6 0 35.5-15.9 35.5-35.5 0-8.1-2.7-15.9-7.8-22.2l-56.2-70.3 0-128 35.2-46.9c8.3-11.1 12.8-24.6 12.8-38.4L304 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16-48 0 0-16c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 16-48 0 0-16c0-17.7-14.3-32-32-32S16 46.3 16 64z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChessRookPiece = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;